import React from 'react';
import { Card, Typography, Button, Space } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

const { Text } = Typography;

const CodeBlock = ({
  code,
  description,
  subDescription,
  onCopy,
}) => {
  return (
    <div style={{ marginBottom: 16 }}>
      {description && (
        <Text strong style={{ display: 'block', marginBottom: 8, color: 'var(--text-color)' }}>
          {description}
        </Text>
      )}
      <Card
        size="small"
        bodyStyle={{
          backgroundColor: 'var(--primary-color)',
          padding: 16,
          position: 'relative',
          border: '1px solid var(--border-color)',
          borderRadius: '14px',
        }}
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Text style={{ color: '#1890ff', fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {code}
            </Text>
            <Button
              type="text"
              icon={<CopyOutlined />}
              onClick={() => onCopy(code)}
              style={{ color: 'var(--text-color)', marginLeft: 8 }}
            />
          </div>
        </Space>
      </Card>
      {subDescription && (
        <Text type="secondary" style={{ display: 'block', marginTop: 8, color: 'rgba(255, 255, 255, 0.65)' }}>
          {subDescription}
        </Text>
      )}
    </div>
  );
};

export default CodeBlock; 